import { Helmet } from 'react-helmet-async';
import { useSiteData } from '@/hooks/useSiteData';
import { Header } from '@/components/layout/Header';
import { Footer } from '@/components/layout/Footer';
import { Hero } from '@/components/sections/Hero';
import { Quote } from '@/components/sections/Quote';
import { ChefRecommendations } from '@/components/sections/ChefRecommendations';
import { LocationHours } from '@/components/sections/LocationHours';
import { MenuCTA } from '@/components/sections/MenuCTA';

export function Index() {
  const { siteData } = useSiteData();

  return (
    <>
      <Helmet>
        <title>{siteData.title}</title>
        <meta name="description" content={siteData.description} />
        <meta name="keywords" content={siteData.keywords} />
        <meta name="robots" content="max-image-preview:large" />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://dangsvietnameserestaurant.com/" />
        <meta property="og:title" content={siteData.title} />
        <meta property="og:description" content={siteData.description} />
        <meta property="og:image" content="/images/logo.jpg" />

        {/* Twitter */}
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:url" content="https://dangsvietnameserestaurant.com/" />
        <meta property="twitter:title" content={siteData.title} />
        <meta property="twitter:description" content={siteData.description} />
        <meta property="twitter:image" content="/images/logo.jpg" />
        
        {/* Additional SEO */}
        <link rel="canonical" href="https://dangsvietnameserestaurant.com/" />
        <meta name="generator" content="React + Vite" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Helmet>
      
      <div className="min-h-screen flex flex-col">
        <Header />
        <main className="flex-1">
          <Hero />
          <Quote />
          <ChefRecommendations />
          <LocationHours />
          <MenuCTA />
        </main>
        <Footer />
      </div>
    </>
  );
}